<template>
  <div class="flex items-center py-2">
    <template v-if="isMyProfile">
      <span class="ml-1 ds-text-base font-medium text-white" data-cy="my-profile-message">My Profile Preview</span>
    </template>

    <template v-else>
      <span class="ml-1 ds-text-base font-medium text-white" data-cy="user-info">
        {{userFullName}}
        <template v-if="classYear">&bull; {{classYear}}</template>
      </span>
    </template>
  </div>
</template>

<script>
import UserAvatar from "@/components/UserAvatar";
import { mapGetters } from "vuex";

export default {
  components: { UserAvatar },

  computed: {
    ...mapGetters("userData", ["userId"]),

    ...mapGetters("athleteProfile", [
      "athleteId",
      "userFullName",
      "userProfilePhotoUrl",
      "classYear"
    ]),

    isMyProfile() {
      return this.userId == this.athleteId;
    }
  }
};
</script>